module.exports = __webpack_public_path__ + "static/media/reminder-dancing.5c8febc7.gif";